import { RSAA } from 'redux-api-middleware';
import endpoints from '../../utils/endpoints';
import { getPayeeById } from '../commonSelectors/selectors';
import { getExchangeRateRequest, buildRatePayment } from '../../helpers/apiRequestBuilder/rates';
import { getAccountCurrency } from '../accounts/selectors';
import { getChapsPaymentsList } from '../chaps/selectors';
import { getChunkingInfo } from '../api/chunkingActions';
import { submitMultiPartChunkingRequest } from '../api/submitMultiPartChunkingRequest';
import { isBatchTypeUpload } from '../batch/selectors';
import { TYPE_CHAPS } from '../../config';

export const SUBMIT_GET_EXCHANGE_RATES_REQUEST = 'SUBMIT_GET_EXCHANGE_RATES_REQUEST';
export const SUBMIT_GET_EXCHANGE_RATES_SUCCESS = 'SUBMIT_GET_EXCHANGE_RATES_SUCCESS';
export const SUBMIT_GET_EXCHANGE_RATES_FAILURE = 'SUBMIT_GET_EXCHANGE_RATES_FAILURE';
export const SUBMIT_GET_CHAPS_RATES_REQUEST = 'SUBMIT_GET_CHAPS_RATES_REQUEST';
export const SUBMIT_GET_CHAPS_RATES_SUCCESS = 'SUBMIT_GET_CHAPS_RATES_SUCCESS';
export const SUBMIT_GET_CHAPS_RATES_FAILURE = 'SUBMIT_GET_CHAPS_RATES_FAILURE';

export const fetchRatesRequest = (payment, bankId, accountId) => ({
	[RSAA]: {
		endpoint: endpoints.getExchangeRate.resolve(bankId, 'default', accountId),
		method: 'POST',
		types: [SUBMIT_GET_EXCHANGE_RATES_REQUEST, SUBMIT_GET_EXCHANGE_RATES_SUCCESS, SUBMIT_GET_EXCHANGE_RATES_FAILURE],
		headers: { 'x-bpi-version': endpoints.getExchangeRate.x_bpi_version },
		body: JSON.stringify(payment),
	},
});

export const fetchRates = (payment) => (dispatch, getState) => {
	const state = getState();
	const toAccount = getPayeeById(state, payment.toAccount);
	const { bankId } = state.session;
	const accountId = payment.fromAccount;
	const fromAccountCurrency = getAccountCurrency(state, payment.fromAccount);
	const body = getExchangeRateRequest(
		{
			...payment,
			fromAccountCurrency,
		},
		toAccount
	);
	return dispatch(fetchRatesRequest(body, bankId, accountId));
};

export const fetchReviewRatesRequestBody = (state) => {
	const payments = getChapsPaymentsList(state);
	const { bankId } = state.session;
	const { x_bpi_version } = endpoints.getExchangeRate;
	return JSON.stringify({
		batch_list: payments.map((payment) => {
			const toAccount = getPayeeById(state, payment.toAccount);
			const accountId = payment.fromAccount;
			return {
				id: payment.id,
				uri: endpoints.getExchangeRate.resolve(bankId, 'default', accountId),
				method: 'POST',
				x_bpi_version,
				body: buildRatePayment(payment, toAccount),
			};
		}),
	});
};
// eslint-disable-next-line
export const fetchReviewRates = (state) => {
	const body = fetchReviewRatesRequestBody(state);
	const types = [SUBMIT_GET_CHAPS_RATES_REQUEST, SUBMIT_GET_CHAPS_RATES_SUCCESS, SUBMIT_GET_CHAPS_RATES_FAILURE];
	const isFileUploadBatch = isBatchTypeUpload(state);
	if (isFileUploadBatch) {
		const payloadForChunking = JSON.parse(body);
		const fileUploadChunkingDetails = getChunkingInfo(payloadForChunking.batch_list, state, TYPE_CHAPS);
		const { isChunkingRequired } = fileUploadChunkingDetails;
		if (isChunkingRequired) {
			const { totalChunks, chunks, totalItems } = fileUploadChunkingDetails;
			return submitMultiPartChunkingRequest(types, totalChunks, chunks, totalItems);
		}
	}
	return {
		[RSAA]: {
			endpoint: endpoints.multipart.uri,
			method: 'POST',
			types,
			headers: { 'x-bpi-version': endpoints.multipart.x_bpi_version },
			body,
		},
	};
};
